import { Map } from "immutable";
import { LOAD_USER_FAVORITES } from "lib/api/favorites";
import { deserializeRoute } from "lib/api/records";
import { fulfilled } from "lib/promiseMiddlewareHelpers";

const initialState = Map();

// Reducer - DEPRECATED - currently only used for favorites
export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case fulfilled(LOAD_USER_FAVORITES): {
      const routes = action.payload.extras.filter((f) => f.type === "route").map((f) => deserializeRoute(f.route));
      return state.merge(routes.map((r) => [r.id, r]));
    }
    default:
      return state;
  }
};
